module.exports = __webpack_public_path__ + "static/media/5.2ed0a006.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/avatars/5.png
 ** module id = 420
 ** module chunks = 0
 **/